export const dataModelList = {
	gpt3_5t: 'gpt-3.5-turbo',
	gpt4: 'gpt-4',
	gpt4t: 'gpt-4-turbo',
	gpt4o: 'gpt-4o',
	gpt4o_mini: 'gpt-4o-mini',
};

export const defaultDataModel = dataModelList.gpt4o_mini;
